module.exports = __webpack_public_path__ + "assets/loops-active.78e6b2d1.svg";